module.exports = __webpack_public_path__ + "img/1184.8fc0b0e2.png";